<template lang="pug">
div
  UiStack(vertical)
    AttachmentsTab(
      v-if="attachments !== null"
      :data="attachments"
    )
    XmlViewer(:xml="this.data")
</template>

<script>
import XmlViewer from "@/components/XMLViewer/XmlViewer.vue";
import AttachmentsTab from "@/views/PurchaseInvoice/tabs/attachments.vue";

export default {
  components: {
    XmlViewer,
    AttachmentsTab,
  },
  props: ["data", "attachments"],
};
</script>
